export enum REGIONS {
  US_WEST_2 = 'us-west-2',
  EU_CENTRAL_1 = 'eu-central-1',
}
